export const buildInfo = {
  branch: 'main',
  commit: 'fc2fd4b',
  buildDate: '2026-10-30T12:15:44.079Z',
};
